import * as React from 'react';
import { fetchApi, List, makeResetCache, notifyResponse, PageTitle, QueryMulti, Section } from 'gossamer-front-end';
import { Button, Stack } from 'react-bootstrap';
import { CompoundResponse, getFilter } from 'gossamer-unified';
import { Transaction } from 'gossamer-model';
import { useDispatch } from 'react-redux';

export const TestPage = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const makeHandleClick = (path: string) => async () => {
    const resp: CompoundResponse = await fetchApi('POST', '/main' + path);
    notifyResponse(resp);
    resetCache(Transaction.id);
  };
  return (
    <>
      <PageTitle title="Test Page" />
      <Section title="Test A" subtitle="Errors, warnings and infos with successful save">
        <Stack direction="horizontal" gap={5}>
          <Button onClick={makeHandleClick('/test_a')} style={{ width: 200, flexShrink: 0 }}>
            Test A
          </Button>
          <div>
            2 error messages, 2 warning messages, 2 info messages reported by back end logic, but no throw so
            transaction is saved successfully
          </div>
        </Stack>
        <br />
        <QueryMulti
          entity={Transaction}
          queryOptions={{
            where: { and: [getFilter('back_end_path', 'eq', '/test_a')] },
            limit: 5,
          }}
          render={List}
        />
      </Section>
      <Section title="Test B" subtitle="Throw reported as error and fail">
        <Stack direction="horizontal" gap={5}>
          <Button onClick={makeHandleClick('/test_b')} style={{ width: 200, flexShrink: 0 }}>
            Test B
          </Button>
          <div>1 throw reported as an error and transaction is rolled back</div>
        </Stack>
        <br />
        <QueryMulti
          entity={Transaction}
          queryOptions={{
            where: { and: [getFilter('back_end_path', 'eq', '/test_b')] },
            limit: 5,
          }}
          render={List}
        />
      </Section>
    </>
  );
};
